import React from 'react';
import { Box, Chip, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { format } from 'date-fns';

interface SessionsDrillDownProps {
  /** null = still loading; [] = loaded, nothing found. */
  sessions: any[] | null;
}

// Shared drill-down table (individual join/leave connections behind one summary row's totals) —
// used by both the employee's MyMeetingHistory and the admin LiveKitAdmin report, so the two
// never drift in how they present the same underlying data.
const SessionsDrillDown: React.FC<SessionsDrillDownProps> = ({ sessions }) => {
  if (sessions === null) {
    return (
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (sessions.length === 0) {
    return <Box sx={{ p: 2, color: 'text.secondary' }}>No individual sessions found.</Box>;
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {['Join', 'Leave', 'Duration', 'Status'].map(h => (
            <TableCell key={h} sx={{ fontWeight: 600 }}>{h}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {sessions.map(s => (
          <TableRow key={s.id}>
            <TableCell>{format(new Date(s.joinTime), 'dd MMM yyyy, HH:mm:ss')}</TableCell>
            <TableCell>{s.leaveTime ? format(new Date(s.leaveTime), 'dd MMM yyyy, HH:mm:ss') : '—'}</TableCell>
            <TableCell>{s.durationSeconds != null ? `${Math.round(s.durationSeconds / 60)} min` : '—'}</TableCell>
            <TableCell>
              {s.connected ? <Chip label="Connected" color="success" size="small" /> : 'Ended'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SessionsDrillDown;
